import { API } from '@/utils/api/api';

export const validatePlayerCodeApi = async (formData) => {
  return await API.post('default/validate-player', formData);
};
